import { api } from './apiClient';
import {
  EximDashboard, TradeProfile, TradeProfilePayload, EligibleInvoice,
  ExportShipment, ImportShipment, CreateExportShipmentPayload, RecordBrcPayload,
  CreateImportShipmentPayload, RecordCustomsDutyPayload,
} from '../types/exim';

/**
 * Typed client for /api/v1/exim. Mirrors erp-api/src/controllers/exim.js.
 * apiClient unwraps the {status,data} envelope to `data`.
 */
const eximService = {
  getDashboard: () => api.get<EximDashboard>('/exim/dashboard'),

  getTradeProfile: () => api.get<{ profile: TradeProfile | null }>('/exim/trade-profile'),
  upsertTradeProfile: (payload: TradeProfilePayload) => api.put<{ profile: TradeProfile }>('/exim/trade-profile', payload),

  getEligibleSalesInvoices: () => api.get<{ invoices: EligibleInvoice[] }>('/exim/export-shipments/eligible-invoices'),
  listExportShipments: () => api.get<{ shipments: ExportShipment[] }>('/exim/export-shipments'),
  createExportShipment: (payload: CreateExportShipmentPayload) => api.post<{ shipment: ExportShipment }>('/exim/export-shipments', payload),
  recordBrc: (shipmentId: number, payload: RecordBrcPayload) =>
    api.post<{ brc: any; journalEntryId: number; forexGainLoss: number }>(`/exim/export-shipments/${shipmentId}/brc`, payload),

  getEligiblePurchaseInvoices: () => api.get<{ invoices: EligibleInvoice[] }>('/exim/import-shipments/eligible-invoices'),
  listImportShipments: () => api.get<{ shipments: ImportShipment[] }>('/exim/import-shipments'),
  createImportShipment: (payload: CreateImportShipmentPayload) => api.post<{ shipment: ImportShipment }>('/exim/import-shipments', payload),
  recordCustomsDuty: (shipmentId: number, payload: RecordCustomsDutyPayload) =>
    api.post<{ shipment: ImportShipment; journalEntryId: number }>(`/exim/import-shipments/${shipmentId}/customs-duty`, payload),
};

export default eximService;
